import $ from 'jquery';
import 'jquery-ui/ui/widgets/selectmenu';

export const customSelect = () => {
    $("#selectable.selectable").selectmenu({
        position: {
            my: "left top",
            at: "left top+56",
            collision: "none"
        }
    });
}
